import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils/cn'

interface LoadingStateProps {
  /** Variant determines the type of loading display */
  variant?: 'spinner' | 'skeleton'
  /** Text to display below the spinner */
  text?: string
  /** Number of skeleton items to show */
  skeletonCount?: number
  /** Additional CSS classes */
  className?: string
}

export function LoadingState({
  variant = 'spinner',
  text = 'Loading...',
  skeletonCount = 3,
  className,
}: LoadingStateProps) {
  if (variant === 'skeleton') {
    return (
      <div className={cn('animate-pulse space-y-4', className)}>
        <div className="h-8 w-48 bg-muted rounded" />
        <div className="h-10 w-full bg-muted rounded" />
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: skeletonCount }).map((_, i) => (
            <div key={i} className="h-48 bg-muted rounded-lg" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className={cn('flex items-center justify-center p-12', className)}>
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-muted-foreground mx-auto mb-4" />
        <p className="text-muted-foreground">{text}</p>
      </div>
    </div>
  )
}
